module.exports = __webpack_public_path__ + "img/oeaw.fac76911.png";